// Keyed by the tab route names used in the section routes' `meta.tabs()` — a renamed tab
// must be updated here too. Tabs without an entry are not menu-gated.
export const MENU_TAB_ACTIONS = {
  projects: 'GetMenuAllProjects',
  configRepositories: 'GetMenuConfigRepositories',
  stacks: 'GetMenuAllStacks',
  catalogRepositories: 'GetMenuCatalogRepositories',
  infraTools: 'GetMenuTools',
  inventory: 'GetMenuInventory',
  events: 'GetMenuEvents',
  pipelinesOverview: 'GetMenuPipelinesOverview',
  cloudCostManagementDashboard: 'GetMenuFinopsDashboard',
  cloudCostManagementSettings: 'GetMenuFinopsSettings',
  credentials: 'GetMenuCredentials',
  infraPolicies: 'GetMenuInfrapolicies',
  roles: 'GetMenuRoles',
  apiKeys: 'GetMenuAPIKeys',
}

// Menu actions gating each Dashboard key-numbers stat: a stat is hidden when the menu
// section or tab it links to is hidden. Stats without an entry (members, teams) are not
// menu-gated.
export const KEY_NUMBERS_MENU_ACTIONS = {
  projects: ['GetMenuProjects', 'GetMenuAllProjects'],
  pipelines: ['GetMenuObservability', 'GetMenuPipelinesOverview'],
  stacks: ['GetMenuStacks', 'GetMenuAllStacks'],
  credentials: ['GetMenuSecurity', 'GetMenuCredentials'],
}

export const MENU_SECTIONS = [
  { name: 'dashboard', menuAction: 'GetMenuDashboard', icon: 'dashboard' },
  { name: 'projectsSection', menuAction: 'GetMenuProjects', icon: 'folder' },
  { name: 'stacksSection', menuAction: 'GetMenuStacks', icon: 'fa-solid:cubes' },
  { name: 'resourcesSection', menuAction: 'GetMenuResources', icon: 'mdi:dns' },
  { name: 'observabilitySection', menuAction: 'GetMenuObservability', icon: 'explore' },
  { name: 'cloudCostManagementSection', routeName: 'cloudCostManagement', menuAction: 'GetMenuFinops', icon: 'attach-money' },
  { name: 'securitySection', menuAction: 'GetMenuSecurity', icon: 'security' },
]

/**
 * First section of `sections` that is menu-visible and whose route is accessible, or
 * `undefined` if none qualifies. Assumes the actions are already evaluated: `isDenied`
 * reports unevaluated actions as not denied. Sections without a `menuAction` (plugin
 * widgets) are always menu-visible, only `canAccessRoute` gates them.
 *
 * @param {(action?: string) => boolean} isDenied
 * @param {(section: Object) => boolean} [canAccessRoute]
 * @param {Object[]} [sections]
 * @returns {Object|undefined}
 */
export const firstVisibleMenuSection = (isDenied, canAccessRoute = () => true, sections = MENU_SECTIONS) => {
  return sections.find((section) => !isDenied(section.menuAction) && canAccessRoute(section))
}
